angular.module('impactx.rfq').directive('rfqItem', function () {
   return {
       scope: {
           item: '=',
           selectedItems: '=',
           trns: '=',
           showNet: "=",
           showGross: "=",
           showComments: "=",
           showChange: "=",
           selectedOtherItems: "=",
           showCatalogNet: "=",
           readOnly: "=",
           form: "="
       },
       controller: 'ItemCtrl',
       restrict: 'E',
       templateUrl: 'modules/rfq/templates/rfqitem.tmpl.html',
       transclude: true
   };
});